import { render, staticRenderFns } from "./Columns.vue?vue&type=template&id=f481ac3a&scoped=true"
import script from "./Columns.vue?vue&type=script&lang=ts"
export * from "./Columns.vue?vue&type=script&lang=ts"
import style0 from "./Columns.vue?vue&type=style&index=0&id=f481ac3a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f481ac3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f481ac3a')) {
      api.createRecord('f481ac3a', component.options)
    } else {
      api.reload('f481ac3a', component.options)
    }
    module.hot.accept("./Columns.vue?vue&type=template&id=f481ac3a&scoped=true", function () {
      api.rerender('f481ac3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/view-editor/Columns.vue"
export default component.exports